import { RiskScoreEnum } from 'api';

export type RiskScores = keyof typeof RiskScoreEnum;

export enum RiskScoreDescriptionEnum {
  LR = 'Low Risk',
  LI = 'Low Risk - Inspect',
  HR = 'High Risk',
  ND = 'Non-Discretionary',
  PD = 'Pending',
}
